"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CrossInsideCircle = exports.CircularTickIcon = exports.EmailIcon = exports.PhoneIcon = exports.RequestSent = exports.PlusIcon = exports.MinusIcon = exports.BackArrow = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable import/prefer-default-export */


var BackArrow = function BackArrow(_ref) {
  var width = _ref.width;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: width,
      cursor: "pointer"
    },
    version: "1.1",
    viewBox: "0 0 14 11"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, _react.default.createElement("g", {
    fillRule: "nonzero",
    stroke: "#484848",
    transform: "translate(-28 -90)"
  }, _react.default.createElement("g", {
    transform: "translate(29 90)"
  }, _react.default.createElement("polyline", {
    points: "5 0 0 5.4615 5 11"
  }), _react.default.createElement("path", {
    d: "m0.30034 5.5967h11.5"
  })))));
};

exports.BackArrow = BackArrow;

var MinusIcon = function MinusIcon(_ref2) {
  var width = _ref2.width,
      color = _ref2.color;
  return _react.default.createElement("svg", {
    version: "1.1",
    style: {
      width: width,
      cursor: "pointer"
    },
    viewBox: "0 0 15 4",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    transform: "translate(-644 -380)",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    transform: "translate(633 363)",
    fill: color || "#43484D"
  }, _react.default.createElement("g", {
    transform: "translate(12 18)"
  }, _react.default.createElement("path", {
    d: "m6.1538 2.2462c-0.7732 0-1.4-0.6268-1.4-1.4 0-0.7732 0.6268-1.4 1.4-1.4h5.5385c1.8667 0 1.8667 2.8 0 2.8h-11.077c-0.7732 0-1.4-0.6268-1.4-1.4 0-0.7732 0.6268-1.4 1.4-1.4h11.077v2.8h-5.5385z",
    fillRule: "nonzero"
  })))));
};

exports.MinusIcon = MinusIcon;

var PlusIcon = function PlusIcon(_ref3) {
  var width = _ref3.width,
      color = _ref3.color;
  return _react.default.createElement("svg", {
    version: "1.1",
    style: {
      width: width,
      cursor: "pointer"
    },
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    transform: "translate(-742 -374)",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    transform: "translate(633 363)",
    fill: color || "#43484D",
    fillRule: "nonzero"
  }, _react.default.createElement("g", {
    transform: "translate(109 11)"
  }, _react.default.createElement("path", {
    d: "m6.4462 9.2462h-4.1385c-0.7732 0-1.4-0.6268-1.4-1.4s0.6268-1.4 1.4-1.4h4.1385v-4.4846c0-1.8667 2.8-1.8667 2.8 0v4.4846h4.1385v2.8h-4.1385v4.1385c0 0.7732-0.6268 1.4-1.4 1.4s-1.4-0.6268-1.4-1.4v-4.1385zm2.8-2.8h4.1385c1.8667 0 1.8667 2.8 0 2.8h-4.1385v-2.8z"
  })))));
};

exports.PlusIcon = PlusIcon;

var RequestSent = function RequestSent(_ref4) {
  var width = _ref4.width,
      color = _ref4.color;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: width
    },
    version: "1.1",
    viewBox: "0 0 52 52"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    stroke: color || "#484848",
    strokeWidth: "2",
    transform: "translate(-369 -1291)"
  }, _react.default.createElement("g", {
    transform: "translate(370 1292)"
  }, _react.default.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "25",
    fillRule: "nonzero"
  }), _react.default.createElement("polyline", {
    strokeLinecap: "round",
    points: "12 26.125 19.67 34 37.2 16"
  })))));
};

exports.RequestSent = RequestSent;

var PhoneIcon = function PhoneIcon(_ref5) {
  var width = _ref5.width,
      color = _ref5.color;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: "20",
    viewBox: "0 0 20 20"
  }, _react.default.createElement("g", {
    fill: "none",
    stroke: color || "#979797"
  }, _react.default.createElement("rect", {
    width: "10",
    height: "18",
    x: "5",
    y: "1",
    rx: "3"
  }), _react.default.createElement("circle", {
    cx: "10",
    cy: "16",
    r: "1"
  }), _react.default.createElement("path", {
    strokeLinecap: "round",
    d: "M9 3h2"
  })));
};

exports.PhoneIcon = PhoneIcon;

var EmailIcon = function EmailIcon(_ref6) {
  var width = _ref6.width,
      color = _ref6.color;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: "20",
    viewBox: "0 0 20 20"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: color || "#A0A0A0"
  }, _react.default.createElement("path", {
    d: "M2.426 4c-.435 0-.794.392-.794.867v9.822c0 .475.359.867.794.867h14.832c.436 0 .795-.392.795-.867V4.867c0-.475-.36-.867-.795-.867H2.426z"
  }), _react.default.createElement("path", {
    d: "M1.632 4.889l8.21 6.222 8.21-6.222M1.632 15.556l6.386-5.334m10.035 5.334l-6.386-5.334"
  })));
};

exports.EmailIcon = EmailIcon;

var CircularTickIcon = function CircularTickIcon(_ref7) {
  var width = _ref7.width,
      color = _ref7.color;
  return _react.default.createElement("svg", {
    version: "1.1",
    style: {
      width: width
    },
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    transform: "translate(-27 -1150)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, _react.default.createElement("g", {
    transform: "translate(28 1151)",
    stroke: color ? color : '#484848'
  }, _react.default.createElement("path", {
    d: "m9.8852 19.487c5.381 0 9.7436-4.3626 9.7436-9.7436 0-5.381-4.3626-9.7436-9.7436-9.7436-5.381 0-9.7436 4.3626-9.7436 9.7436 0 5.381 4.3626 9.7436 9.7436 9.7436z",
    strokeWidth: "2.0103"
  }), _react.default.createElement("polyline", {
    points: "5.8501 9.4248 8.6152 12.261 14.055 7.133",
    strokeLinejoin: "round",
    strokeWidth: "2.0513"
  }))));
};

exports.CircularTickIcon = CircularTickIcon;

var CrossInsideCircle = function CrossInsideCircle(_ref8) {
  var width = _ref8.width,
      color = _ref8.color;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: width,
      cursor: 'pointer'
    },
    version: "1.1",
    viewBox: "0 0 26 26"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    transform: "translate(-800 -770)"
  }, _react.default.createElement("g", {
    stroke: color ? color : '#f15252',
    strokeWidth: "2",
    transform: "translate(801 771)"
  }, _react.default.createElement("path", {
    d: "m11.692 23.385c6.4572 0 11.692-5.2351 11.692-11.692 0-6.4572-5.2351-11.692-11.692-11.692-6.4572 0-11.692 5.2351-11.692 11.692 0 6.4572 5.2351 11.692 11.692 11.692z"
  }), _react.default.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(7.2 7.2)"
  }, _react.default.createElement("path", {
    d: "m0 0 9.6 9.6"
  }), _react.default.createElement("path", {
    d: "M9.6,0 L0,9.6"
  })))));
};

exports.CrossInsideCircle = CrossInsideCircle;